"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableContext = exports.TableContext = void 0;
const react_1 = require("react");
exports.TableContext = (0, react_1.createContext)({
    data: [],
    selected: new Set(),
    sorters: {},
    innerPadding: false,
    loading: false,
    colSpanRef: { current: 0 },
    setData: () => null,
    select: () => null,
    selectAll: () => null,
    removeItem: () => null,
    setLoading: () => null,
    changeSorter: () => null,
    removeSelectedItems: () => null,
});
function useTableContext() {
    return (0, react_1.useContext)(exports.TableContext);
}
exports.useTableContext = useTableContext;
